import api from '../services/api';

/**
 * Get paginated list of employees
 */
export async function getEmployees(queryParams) {
  try {
    let endpoint = '/api/employees';
    if (queryParams && queryParams.toString()) {
      endpoint += `?${queryParams.toString()}`;
    }
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error fetching employees:', error);
    throw error;
  }
}

/**
 * Get a single employee by ID
 */
export async function getEmployeeById(id) {
  try {
    const response = await api.get(`/api/employees/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching employee ${id}:`, error);
    throw error;
  }
}

/**
 * Create a new employee
 */
export async function createEmployee(data) {
  try {
    const response = await api.post('/api/employees', data);
    return response.data;
  } catch (error) {
    console.error('Error creating employee:', error);
    throw error;
  }
}

/**
 * Update an existing employee
 */
export async function updateEmployee(id, data) {
  try {
    const response = await api.put(`/api/employees/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating employee ${id}:`, error);
    throw error;
  }
}

/**
 * Delete an employee
 */
export async function deleteEmployee(id) {
  try {
    const response = await api.delete(`/api/employees/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting employee ${id}:`, error);
    throw error;
  }
}

/**
 * Import employees from CSV file
 */
export async function importEmployees(file) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/api/employees/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error importing employees:', error);
    throw error;
  }
}

/**
 * Export employees to CSV
 */
export async function exportEmployees() {
  try {
    const response = await api.get('/api/employees/export', {
      responseType: 'blob',
    });
    
    // Create a download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `employees_export_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return { status: 1, message: 'Export started' };
  } catch (error) {
    console.error('Error exporting employees:', error);
    throw error;
  }
}

/**
 * Get employee statistics
 */
export async function getEmployeeStatistics() {
  try {
    const response = await api.get('/api/employees/statistics');
    return response.data;
  } catch (error) {
    console.error('Error fetching employee statistics:', error);
    throw error;
  }
}
